import { render, staticRenderFns } from "./SyncSettingsModal.vue?vue&type=template&id=4055011e&scoped=true"
import script from "./SyncSettingsModal.vue?vue&type=script&lang=js"
export * from "./SyncSettingsModal.vue?vue&type=script&lang=js"
import style0 from "./SyncSettingsModal.vue?vue&type=style&index=0&id=4055011e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4055011e",
  null
  
)

export default component.exports